module.exports = __webpack_public_path__ + "static/media/who-we-are-24-25.7578a935.png";